module.exports = __webpack_public_path__ + "static/media/plastic.ca76dbc8.png";